import { forwardRef, type AnchorHTMLAttributes } from 'react';

import { cx, focusRingClass, interactiveClass } from './shared';

export interface LinkProps extends AnchorHTMLAttributes<HTMLAnchorElement> {
  variant?: 'accent' | 'neutral';
  isDisabled?: boolean;
}

const variantClass = {
  accent: 'text-accent underline decoration-accent/50 hover:text-accent-hover',
  neutral: 'text-ink underline decoration-border-strong hover:text-accent-ink',
};

export const Link = forwardRef<HTMLAnchorElement, LinkProps>(
  ({ variant = 'accent', isDisabled = false, className, onClick, tabIndex, ...rest }, ref) => (
    <a
      ref={ref}
      className={cx(
        focusRingClass,
        interactiveClass,
        'inline-flex min-h-control-comfortable items-center rounded-control px-1 text-control font-semibold underline-offset-4',
        variantClass[variant],
        isDisabled && 'cursor-not-allowed text-ink-muted no-underline',
        className,
      )}
      aria-disabled={isDisabled || undefined}
      tabIndex={isDisabled ? -1 : tabIndex}
      onClick={(event) => {
        if (isDisabled) {
          event.preventDefault();
          return;
        }
        onClick?.(event);
      }}
      {...rest}
    />
  ),
);

Link.displayName = 'Link';
